module.exports = __webpack_public_path__ + "img/img-main-bg05.4d027d24.png";